import React from 'react'
import { Platform, ScrollView, StyleSheet, View } from 'react-native'
import { Card, useTheme } from 'react-native-paper'
import { useSelector } from 'react-redux'
import { getRecipes } from 'src/recipes'
import RecipeCard from './RecipeCard'

const Recipes = ({ children, onPress, onSwap }) => {
  const keys = useSelector(({ recipes: { keys } }) => keys)
  const meals = useSelector(({ settings: { meals } }) => meals)

  const recipes = getRecipes(keys, meals)
  const { colors } = useTheme()

  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor: colors.surface,
          paddingTop: Platform.OS == 'ios' ? 50 : 10,
        },
      ]}
    >
      <ScrollView
        style={styles.scrollContainer}
        showsHorizontalScrollIndicator={false}
      >
        <Card style={styles.instructionCard}>{children}</Card>

        {recipes.map((recipe, index) => (
          <RecipeCard
            key={index}
            recipe={recipe}
            style={styles.mealCard}
            onSwap={onSwap ? () => onSwap(index) : null}
            onPress={onPress ? () => onPress(recipe) : null}
          />
        ))}
      </ScrollView>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
  },
  scrollContainer: {
    padding: 5,
    width: '100%',
    margin: 'auto',
    maxWidth: '700px',
  },
  instructionCard: {
    paddingVertical: 25,
  },
})

export default Recipes
